import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  segments: []
}

const mutations = {  
  SET_SEGMENTS (state, payload) {
    state.segments = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  segmentList: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&_id[]=${element}`
      }
    }

    return Vue.http.get(`${env.API}/api/segment${query}`)    
      .then((response) => {        
        context.commit('SET_SEGMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  segmentSelectList: (context, data) => {    
    return Vue.http.get(`${env.API}/api/segment/select-list`)    
      .then((response) => {        
        context.commit('SET_SEGMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  ByTravelId: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {  
      for (let element of data.ids) {                 
        query += `&_id[]=${element}`
      }
    }
    return Vue.http.get(`${env.API}/api/segment/travel/${data.travel}${query}`)    
      .then((response) => {        
        context.commit('SET_SEGMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  ByTravelIds: (context, data) => {
    return Vue.http.get(`${env.API}/api/segment/travels/${data.travels}`)
      .then((response) => {
        context.commit('SET_SEGMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getSegmentById: (context, id) => {
    if (id == undefined) {
      return null
    } else {
      return Vue.http.get(`${env.API}/api/segment/by-id/${id}`)    
        .then((response) => {                
          return response.body.message
        })
        .catch((error) => {
          return context.commit('API_FAILURE', error)
        })
    }
  },
  getSegmentByRoles: (context, ids) => {
    return Vue.http.post(`${env.API}/api/segment/by-roles`, ids)    
      .then((response) => {
        context.commit('SET_SEGMENTS', response.body.message)              
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getSegments: (state) => state.segments
}

export const segment = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/segment.js